import { toast } from 'sonner';
import type { TOpenEvaluationSummary } from 'types/evaluation.types';
import { EEvaluationType } from 'types/evaluation.types';

const evaluateOpen = (question: any, _language: string, _Evaluation: any, categories: any) => {
  const temp: TOpenEvaluationSummary = {
    id: question.id,
    evaluation: { id: '', scoring_category: '', weight: 0 },
    intentEvaluation: {},
    summary: {
      [EEvaluationType.Bonus]: 0,
      [EEvaluationType.Warning]: 0,
      [EEvaluationType.Disqualified]: 0,
      [EEvaluationType.Info]: 0,
    },
    isDefault: true,
  };

  const categoryId = question.scoring_category;
  if (!categoryId || !categoryId.length) {
    return null;
  }

  if (!categories || !categories.list || !categories.list.length) {
    return null;
  }

  // console.log('handleOpen', categories, categoryId)
  if (categories.list.includes(categoryId)) {
    const category = categories[categoryId];
    // console.log('handleOpen includes category', category)
    temp.evaluation = {
      id: categoryId,
      scoring_category: categoryId,
      weight: category.weight,
    };
  } else {
    toast.error(`Scoring category ${categoryId} is not part of the scoring list.`);
  }
  return temp;
};

export default evaluateOpen;
